export const handleFooterLinkClick = (link, onManageCookies, handleOnClick) =>
  link.cookiesLink ? onManageCookies : handleOnClick;
